import React from 'react';
import PropTypes from 'prop-types';
import { Crumb } from 'components/atoms';
import { BreadCrumbs } from 'components/molecules';

function joinUrl(base, path) {
	if (!base) return path || '';
	if (!path) return base;
	return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}

export function FacilityBreadcrumbs({ facility, baseUrl, crumbs = [] }) {
	const facilityCrumbs = facility?.name
		? [
				<Crumb
					key="facility"
					label={facility.name}
					to={joinUrl(baseUrl, facility.url)}
					isLast={!crumbs.length}
				/>,
				...crumbs,
			]
		: crumbs;

	return (
		<BreadCrumbs
			location={facility?.seoLocation}
			cityUrl={facility?.cityUrl}
			stateUrl={facility?.stateUrl}
			baseUrl={baseUrl}
			crumbs={facilityCrumbs}
		/>
	);
}

FacilityBreadcrumbs.propTypes = {
	facility: PropTypes.shape({
		name: PropTypes.string,
		url: PropTypes.string,
		cityUrl: PropTypes.string,
		stateUrl: PropTypes.string,
		seoLocation: PropTypes.object,
	}),
	baseUrl: PropTypes.string,
	crumbs: PropTypes.arrayOf(PropTypes.node),
};

export default FacilityBreadcrumbs;
